import { render, staticRenderFns } from "./OrderPrices.vue?vue&type=template&id=4e9becbf&scoped=true&"
import script from "./OrderPrices.js?vue&type=script&lang=js&"
export * from "./OrderPrices.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=4e9becbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9becbf",
  null
  
)

export default component.exports